import axiosInstance from '@/components/utils/axiosInstance';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
  }
});

/** Apps that may deliver assessment results (organization owner only). */
export const getLinkedApps = () =>
  axiosInstance.get('/api/linked-app/', {
    ...authConfig(),
    params: {page_size: 100}
  });

/** Create an app; the response contains the key, shown only this once. */
export const createLinkedApp = (name: string) =>
  axiosInstance.post('/api/linked-app/', {name}, authConfig());

export const updateLinkedApp = (id: number, payload: any) =>
  axiosInstance.patch(`/api/linked-app/${id}/`, payload, authConfig());

/** Replace the key; the old key stops working. The new key is shown once. */
export const newLinkedAppKey = (id: number) =>
  axiosInstance.post(`/api/linked-app/${id}/new-key/`, null, authConfig());

/** Delete an app that never delivered a result. */
export const deleteLinkedApp = (id: number) =>
  axiosInstance.delete(`/api/linked-app/${id}/`, authConfig());

/** An assessment with all its versions, reached through the step. */
export const getAssessmentHistory = (id: number, stepId: number) =>
  axiosInstance.get(`/api/assessment-registration/${id}/`, {
    ...authConfig(),
    params: {step_id: stepId}
  });
